import React from 'react';
import { theme } from '../../theme';

// <purpose>Navy KPI card showing reanalysis tier counts (1×/2×/3× repetitions) with approval subtotals.</purpose>
// <dependencies>reanalyseVerlauf DTO field (Phase 5+)</dependencies>
// <constraints>No 4+ tier on FE — intentional omission. Admin sees 4+ in PDF retry-distribution block only.</constraints>

type Tier = { total: number; approved: number };

type Props = {
  data: Record<string, Tier> | undefined;
};

const TIERS: Array<{ key: string; label: string }> = [
  { key: '1', label: '1× Wdh.' },
  { key: '2', label: '2× Wdh.' },
  { key: '3', label: '3× Wdh.' },
];

export const ReanalyseVerlaufCard: React.FC<Props> = ({ data }) => (
  <div style={{
    background: theme.colors.navy,
    color: 'white',
    padding: 16,
    borderRadius: 6,
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
  }}>
    <div style={{
      fontSize: 11, opacity: 0.7, textTransform: 'uppercase', letterSpacing: 0.5,
      marginBottom: 12, fontFamily: theme.font.family,
    }}>
      Reanalyse-Verlauf
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: 10, flex: 1 }}>
      {TIERS.map(({ key, label }, i) => {
        const t = data?.[key] ?? { total: 0, approved: 0 };
        const isLast = i === TIERS.length - 1;
        return (
          <div key={key} style={{
            display: 'flex',
            alignItems: 'baseline',
            gap: 8,
            borderBottom: isLast ? 'none' : '1px solid rgba(255,255,255,0.15)',
            paddingBottom: isLast ? 0 : 6,
          }}>
            <div style={{ fontSize: 22, fontWeight: 700, fontFamily: theme.font.family }}>{t.total}</div>
            <div style={{ fontSize: 11, opacity: 0.8, lineHeight: 1.2, fontFamily: theme.font.family }}>
              {label}<br />
              {/* WCAG 1.4.3 — opacity 0.6 white over navy = 4.47:1 (fail at 11px normal); 0.7 = 6.2:1 */}
              <span style={{ opacity: 0.7 }}>{t.approved} genehmigt</span>
            </div>
          </div>
        );
      })}
    </div>
  </div>
);
